export const PAYOUT_ACCOUNTS_PATH = '/dashboard/settings/payout-accounts' as const
export const PAYOUT_ONBOARDING_PATH = `${PAYOUT_ACCOUNTS_PATH}/onboarding` as const
export const PAYOUTS_PATH = '/dashboard/payouts' as const
